import * as CubeTree from '../../cubeTree/index';
import Select from '../select/index';

/**
 * 查找需要被删除的cube
 *
 * 1. 先找货架、画布中的组件
 * 2. 再找层板
 * 3. 商品、隔板、文本框
 */
function findDelTargets(cubeIds: Array<CubeId>): Array<CubeId> {
    let result: Set<CubeId> = new Set();

    // 找货架
    cubeIds.forEach((cubeId: CubeId): void => {
        if (CubeTree.isShelf(cubeId) || CubeTree.isFreezer(cubeId)) {
            result.add(cubeId);
            return;
        }

        if (CubeTree.isInStage(cubeId)) {
            result.add(cubeId);
        }
    });

    // 找层板
    cubeIds.forEach((cubeId: CubeId): void => {
        if (!CubeTree.isPartition(cubeId)) {
            return;
        }

        if (CubeTree.isInStage(cubeId)) {
            result.add(cubeId);
            return;
        }

        let cubeShelf: CubeId|null = CubeTree.findCubeShelf(cubeId);

        if (cubeShelf && !result.has(cubeShelf)) {
            result.add(cubeId);
        }
    });

    // 找商品、隔板、文本框
    cubeIds.forEach((cubeId: CubeId): void => {
        if (!CubeTree.isGoods(cubeId)
            && !CubeTree.isBafflePlate(cubeId)
            && !CubeTree.isTextarea(cubeId)) {
            return;
        }

        if (CubeTree.isInStage(cubeId)) {
            result.add(cubeId);
            return;
        }

        let cubeShelf: CubeId|null = CubeTree.findCubeShelf(cubeId);
        let cubeLayer: CubeId|null = CubeTree.findCubeLayer(cubeId);

        if (cubeShelf && !result.has(cubeShelf)
            && cubeLayer && !result.has(cubeLayer)) {
            result.add(cubeId);
        }
    });

    return Array.from(result);
}

// 强删后更新对象收集
function findDelUpdateTargets(delTargets: Array<CubeId>): Array<CubeId> {
    let result: Set<CubeId> = new Set();
    let delTargetsList: Set<CubeId> = new Set(delTargets);

    delTargets.forEach((delTarget: CubeId): void => {
        if (CubeTree.isGoods(delTarget)
            || CubeTree.isBafflePlate(delTarget)
            || CubeTree.isTextarea(delTarget)) {
            let layer: CubeId|null = CubeTree.findCubeLayer(delTarget);

            layer && result.add(layer);
            return;
        }

        if (CubeTree.isPartition(delTarget)) {
            let shelf: CubeId|null = CubeTree.findCubeShelf(delTarget);

            shelf && result.add(shelf);
            return;
        }
    });

    return Array.from(result);
}

function findDelTargetsAllSelect(): Array<CubeId> {
    let allSelected: Array<CubeId> = Select.getAll();
    let needDelCubes: Array<CubeId> = findDelTargets(allSelected);

    return needDelCubes;
}

export {
    findDelTargets,
    findDelUpdateTargets,
    findDelTargetsAllSelect
};
